import React from 'react';
import Pixel from '../../Analytics/VisibilityPixel/VisibilityPixel';
import Button from '../../Input/Button/Button';
import './LeaveReviewCTA.scss';

export default (props) => (
    <div className="component-CallToAction-LeaveReviewCTA">
        <div className="cta-title"> 100% anonymous, 100% impactful</div>
        <div className="cta-description">
            Help millions of women by reviewing your employer.
        </div>
        <div className="get-started-btn-div">
            <Button
                type={'solid'}
                value={'Leave a review'}
                onClick={props.onClick}
            />
        </div>
        {props.metrics.misc_event_count && (
            <Pixel
                metrics={{
                    misc_event_type: props.metrics.misc_event_count,
                    misc_event_count: 1,
                }}
            />
        )}
    </div>
);
